<template>
  <div class="register-container">
    <div class="register-header">
      <div class="register-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="8.5" cy="7" r="4"/>
          <line x1="20" y1="8" x2="20" y2="14"/>
          <line x1="23" y1="11" x2="17" y2="11"/>
        </svg>
      </div>
      <h1>Regisztráció</h1>
      <p>Fiók létrehozása a RSPCT-Core alkalmazásban</p>
    </div>

    <div v-if="hashValid" class="register-form-container">
      <form @submit.prevent="register" class="register-form">

        <!-- Main registree: the dancer -->
        <div class="form-section">
          <div class="section-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <h2>1. Táncos adatok</h2>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="familyname" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Vezetéknév
              </label>
              <input type="text" class="form-control" id="familyname" v-model="dancer_familyname" required />
            </div>
            <div class="form-group">
              <label for="surename" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Keresztnév
              </label>
              <input type="text" class="form-control" id="surename" v-model="dancer_surename" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="email" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Email cím
              </label>
              <input type="email" class="form-control" id="email" v-model="email" :class="{ 'form-control-disabled': !is_admin_reg && email != '' }" required :disabled="!is_admin_reg && email != ''"/>
            </div>
            <div class="form-group">
              <label for="phone" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Telefonszám
              </label>
              <input type="text" class="form-control" id="phone" v-model="dancer_phone" placeholder="Pl: +36 30 111 2233" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="password" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <circle cx="12" cy="16" r="1"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Jelszó
              </label>
              <input type="password" class="form-control" id="password" v-model="password" required />
            </div>
            <div class="form-group">
              <label for="password_again" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <circle cx="12" cy="16" r="1"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Jelszó újra
              </label>
              <input type="password" class="form-control" id="password_again" v-model="password_again" required />
            </div>
          </div>

          <div class="form-group">
            <label for="addr" class="form-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              Lakcím
            </label>
            <input type="text" class="form-control" id="addr" v-model="dancer_addr" placeholder="Pl: 1111 Budapest, Minta tér 1." required />
          </div>

          <div class="form-group">
            <label for="birth_date" class="form-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Születési dátum
            </label>
            <input type="date" class="form-control" id="birth_date" v-model="dancer_birth_date" />
          </div>

          <div class="form-group" v-if="!is_admin_reg">
            <label for="group" class="form-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
              Kívánt csoport
            </label>
            <select class="form-control" id="group" v-model="dancer_group">
              <option selected value="-1">Nincs csoport / később</option>
              <option v-for="grp in grps" :key="grp.id" :value="grp.id">{{ grp.name }}</option>
            </select>
            <div class="form-info">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 16v-4"/>
                <path d="M12 8h.01"/>
              </svg>
              A csoport választás nem végleges! Létszám függvényében az adminisztrátorok módosíthatják!
            </div>
          </div>

          <div class="form-info">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4"/>
              <path d="M12 8h.01"/>
            </svg>
            Az értesítések, üzenetek és fontos információk erre az email címre fognak érkezni.
          </div>
        </div>

        <!-- Optional parent/guardian -->
        <div class="form-section">
          <div class="section-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <h2>2. Szülő / gondviselő (opcionális)</h2>
          </div>

          <div class="form-group">
            <label for="parent_email" class="form-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              Email cím
            </label>
            <input type="email" class="form-control" id="parent_email" v-model="parent_email" />
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="parent_familyname" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Vezetéknév
              </label>
              <input type="text" class="form-control" id="parent_familyname" v-model="parent_familyname" />
            </div>
            <div class="form-group">
              <label for="parent_surename" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Keresztnév
              </label>
              <input type="text" class="form-control" id="parent_surename" v-model="parent_surename" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="parent_phone" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Telefonszám
              </label>
              <input type="text" class="form-control" id="parent_phone" placeholder="Pl: +36 30 111 2233" v-model="parent_phone" />
            </div>
            <div class="form-group">
              <label for="parent_addr" class="form-label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Lakcím
              </label>
              <input type="text" class="form-control" id="parent_addr" placeholder="Pl: 1111 Budapest, Minta tér 1." v-model="parent_addr" />
            </div>
          </div>

          <div class="form-group">
            <label for="parent_birth_date" class="form-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Születési dátum
            </label>
            <input type="date" class="form-control" id="parent_birth_date" v-model="parent_birth_date" />
          </div>

          <div class="form-info">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
            Ha megadod, a szülő/gondviselő is kapni fog értesítéseket. A jelszavát az e-mailen kapott linken állíthatja be.
          </div>
        </div>

        <button type="submit" class="btn btn-primary register-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <line x1="20" y1="8" x2="20" y2="14"/>
            <line x1="23" y1="11" x2="17" y2="11"/>
          </svg>
          Regisztráció
        </button>
      </form>
    </div>

    <div v-if="message" class="alert alert-info">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 16v-4"/>
        <path d="M12 8h.01"/>
      </svg>
      {{ message }}
    </div>
  </div>
</template>

<style scoped>
.register-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 100vh;
}

.register-header {
  text-align: center;
  margin-bottom: 3rem;
}

.register-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 50%;
  margin-bottom: 1.5rem;
  color: white;
  box-shadow: var(--shadow-lg);
}

.register-header h1 {
  color: var(--color-heading);
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.register-header p {
  color: var(--color-text-muted);
  font-size: 1.125rem;
  margin: 0;
}

.register-form-container {
  background: var(--card-bg);
  border-radius: 20px;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.register-form {
  padding: 2.5rem;
}

.form-section {
  margin-bottom: 3rem;
  padding: 2rem;
  background: var(--color-background-mute);
  border-radius: 16px;
  border: 1px solid var(--color-border);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--color-border);
}

.section-header svg {
  color: var(--primary-blue);
  flex-shrink: 0;
}

.section-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--color-heading);
  font-size: 0.875rem;
}

.form-label svg {
  color: var(--primary-blue);
  flex-shrink: 0;
}

.form-control {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 10px;
  background: var(--white);
  color: var(--color-text);
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  transform: translateY(-1px);
}

.form-control::placeholder {
  color: var(--color-text-muted);
}

.form-control-disabled {
  background: var(--gray-100);
  color: var(--color-text-muted);
  cursor: not-allowed;
}

.form-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  background: rgba(37, 99, 235, 0.05);
  border: 1px solid rgba(37, 99, 235, 0.1);
  border-radius: 8px;
  color: var(--primary-blue);
  font-size: 0.875rem;
  font-weight: 500;
}

.form-info svg {
  flex-shrink: 0;
}

.register-btn {
  width: 100%;
  padding: 1.25rem 2rem;
  background: linear-gradient(135deg, var(--primary-blue), var(--primary-blue-light));
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 2rem;
}

.register-btn:hover {
  background: linear-gradient(135deg, var(--primary-blue-dark), var(--primary-blue));
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.register-btn:active {
  transform: translateY(0);
}

.no-access-message {
  text-align: center;
  padding: 3rem 2rem;
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
}

.no-access-message svg {
  color: var(--error);
  margin-bottom: 1rem;
}

.no-access-message h3 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.no-access-message p {
  color: var(--color-text-muted);
  font-size: 1rem;
  margin: 0;
}

.alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 1.5rem;
}

.alert-info {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-blue);
  border: 1px solid rgba(37, 99, 235, 0.2);
}

.alert svg {
  flex-shrink: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .register-container {
    padding: 1rem 0.75rem;
  }

  .register-form {
    padding: 1.5rem;
  }

  .form-section {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .register-header h1 {
    font-size: 2rem;
  }

  .register-header p {
    font-size: 1rem;
  }

  .section-header h2 {
    font-size: 1.25rem;
  }

  .register-btn {
    padding: 1rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .register-container {
    padding: 0.75rem 0.5rem;
  }

  .register-form {
    padding: 1rem;
  }

  .form-section {
    padding: 1rem;
    border-radius: 12px;
  }

  .register-header h1 {
    font-size: 1.75rem;
  }

  .section-header {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .section-header h2 {
    font-size: 1.125rem;
  }

  .form-control {
    padding: 0.75rem 0.875rem;
  }

  .register-btn {
    padding: 0.875rem 1.25rem;
    font-size: 0.95rem;
  }
}
</style>



<script>
import axios from 'axios';
const BACKEND_HOST = '';
export default {
  data() {
    return {
      email:'',
      password:'',
      password_again:'',
      dancer_familyname:'',
      dancer_surename:'',
      dancer_phone:'',
      dancer_addr:'',
      dancer_birth_date:'',
      dancer_group:-1,
      parent_email:'',
      parent_familyname:'',
      parent_surename:'',
      parent_phone:'',
      parent_addr:'',
      parent_birth_date:'',
      message:'',
      grps:[],
      is_admin_reg:false,
      reg_hash:'',
      hashValid: false,
      checkingHash: false,
    };
  },
  mounted(){
    if (this.$route.query.rhash) {
      this.checkingHash = true;
      this.getHashData()
    }
  },
  methods: {
    async register() {
      try {
        if(this.password != this.password_again){
            this.message = 'A jelszó nem egyezik';
            return;
          }
        const response = await fetch(this.$BACKEND_HOST + '/api/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            email: this.email,
            password: this.password,
            dancer_familyname: this.dancer_familyname,
            dancer_surename: this.dancer_surename,
            dancer_phone: this.dancer_phone,
            dancer_addr: this.dancer_addr,
            dancer_birth_date: this.dancer_birth_date,
            dancer_group: parseInt(this.dancer_group),
            parent_email: this.parent_email,
            parent_familyname: this.parent_familyname,
            parent_surename: this.parent_surename,
            parent_phone: this.parent_phone,
            parent_addr: this.parent_addr,
            parent_birth_date: this.parent_birth_date,
            is_admin_reg: this.is_admin_reg,
            reg_hash: this.reg_hash
          })
        });
        const data = await response.json();
        this.message = data.message;
        if(response.status == "200"){
          setTimeout(()=>{
            this.$router.push('/login');
          },1000)
        }
      } catch (error) {
        this.message = 'Error registering user.';
      }
    },
    async getHashData() {
      try {
        const payload = {
          reg_hash : this.$route.query.rhash,
        };

        const response = await axios.post(this.$BACKEND_HOST + '/api/checkreghash', payload);

        if(response.data.message == "done")
        {
          this.email = response.data.dancer_mail;
          this.is_admin_reg = response.data.is_admin_reg;
          this.reg_hash = this.$route.query.rhash;
          this.hashValid = true;
        } else {
          this.hashValid = false;
        }
      } catch (error) {
        console.error('Error getting email from hash:', error);
        this.hashValid = false;
      } finally {
        this.checkingHash = false;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    fetch(`${BACKEND_HOST}/api/settings/groups/info`)
      .then(response => {

        return response.json();
      })
      .then(data => {
        next(vm => {

          vm.grps = data.groups;
          vm.loading = false;
        });
      })
      .catch(err => {
        next(vm => {
          vm.error = err.message;
          vm.loading = false;
        });
      });

  }
};
</script>


   